import { render, staticRenderFns } from "./AttributePanel.vue?vue&type=template&id=3b9fd02d&scoped=true"
import script from "./AttributePanel.vue?vue&type=script&lang=js"
export * from "./AttributePanel.vue?vue&type=script&lang=js"
import style0 from "./AttributePanel.vue?vue&type=style&index=0&id=3b9fd02d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fd02d",
  null
  
)

export default component.exports